import React, { Component } from "react";
import axios from "axios";
import { apiUrl, apiUrl3 } from "../../config/config";
import classnames from "classnames";
import $ from "jquery";
import socketIOClient from "socket.io-client";
import { MDBDataTable } from "mdbreact";
import ProgressBtn from "../../components/common/ProgressButton";
import TopNav from "../../components/common/TopNav";
import SideBar from "../../components/common/SideBar";
import LiveTag from "../../components/common/LiveTag";
import AddModalComplete from "../verifier/AddModalComplete";
import "react-dropdown/style.css";
import { Toaster, toast } from "react-hot-toast";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

import "./verifierhome.css";

import Select from "react-select";
// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from "worker-loader!./worker.js";
import { ar } from "date-fns/locale";
import url from "socket.io-client/lib/url";

// const socket = socketIOClient("https://web.mybiocalculus.com:5000");

const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: "10px",
    position: "relative",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "100%",
    opacity: 0.4,
    borderRadius: 4,
  },
};
class QC_Home extends Component {
  constructor() {
    super();
    const menus = [
      { title: "Verifier Home", url: "/verifier-home" },
      { title: "Patient list", url: "/patient-list" },
      { title: "Labled Patients", url: "/labled-patients" },
      { title: "Verified", url: "/verification-completed" },

    ];
    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
    }
    if (localStorage.getItem("AdminUser") === "8") {
      menus.splice(3, 0, { title: "Device Details", url: "/device-details" });
      menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
    }

    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
    }
    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
    }
    if (localStorage.getItem("AdminUser") === "8") {
      menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
    }
    if (localStorage.getItem("AdminUser") === "8") {
      menus.splice(6, 0, {
        title: "Supported Person",
        url: "/supported-persons",
      });

      }
       if (localStorage.getItem("AdminUser") === "8") {
        menus.splice(6, 0, {
          title: "Reset Password",
          url: "/ResetPassword",
        });
    }
    this.state = {
      menus,
      isModalCompleteOpen: false,
      profileLink: "verifier-profile",
      patients: [],
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
      errors: {},
      userid: "",
      duration: "",
      smoking: "",
      diabetes: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      dob: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      thyroid_function: "",
      cardiac_surgery: "",
      doctors: [],
      verifiers: [],
      selectedVerifierIds: [],
      selectedVerifiers: [],
      doctor_id: "",
      doctor_name: "Choose",
      selectedDoctor: null,
      data: {},
      prog_data: 0,

      // socketNew: socket,
      patientDetails: null,
      ipop: "",
      priority: "",
      reportstatus: "",
      percentageVerified: "",
      verifiertype: "",
      comments: "",
      customermailid: "",
      mailuserid: "",
      device_id: "",
      patientName: "",
      mailsubject: "",
      whatsappNumber: "",
      arrythymia: "",
      whatsappUserid: "",
      columns: [],
      rows: [],
      searchQuery: "",
      currentPage: 1,
      rowsPerPage: 50,
      pacemaker: false,
      issueReport: "",
      reportPhone: "",
      selectedType: "customer", // Add this line to set the default value
      patientmailid: "",
      patientmailsubject: "",
      patientwhatsappNumber: "",
      patientwhatsappMessage: "",
      loadingEditModal: false, // Add loading state for edit modal
      patientsLoaded: false, // first patient list has arrived (until then show "Loading patients...")
      patientsLoadError: false,
      supportPersons: [], // list from API
      supportPerson: "", // selected support person id
      supportLevel: "",
      supportedMatter: "",
      prioritizeData: "No", // <-- Add this line for the new field
      clinicalCondition: "", // <-- Add this line for the new field
    };
    this.selectItem = this.selectItem.bind(this);
    this.getInfo = this.getInfo.bind(this);
    this.sentMailReport = this.sentMailReport.bind(this);
    this.sentWhatsappReport = this.sentWhatsappReport.bind(this);
    this.preventDefault = this.preventDefault.bind(this);
    this.filterRows = this.filterRows.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
  }

  componentDidMount() {
    if (
      (localStorage.getItem("verifiertype") !== "8") &
      (localStorage.getItem("verifiertype") !== "2")
    ) {
      this.props.history.push("/error");
    } else {
      this.fetchData();
      this.interval = setInterval(this.fetchData, 30000); // Call fetchData every 30 seconds
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval); // Clear the interval when the component unmounts
  }

  fetchData = (e) => {
    const verifiertype = localStorage.getItem("verifiertype");
    this.setState({ verifiertype: verifiertype });
    const worker = new Worker();

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    var newstat = this;

    worker.postMessage({
      name: "alldoctors",
      url: apiUrl + "api/users/alldoctors",
    });
    worker.onmessage = function (event) {};
    worker.addEventListener("message", function (event) {
      newstat.setState({ ["doctors"]: event.data });
    });

    axios
      .get(apiUrl + "api/users/getVerifierPatients")
      .then((res) => {
        const today = new Date().toISOString().split("T")[0];
        const sortedData = res.data
          .filter((patient) => {
            const reportDate = new Date(patient.ReportGeneration);
            if (isNaN(reportDate)) return false; // Ensure the date is valid
            return (
              patient.QC === false &&
              reportDate.toISOString().split("T")[0] === today
            );
          })
          .sort((a, b) => {
            const reportOrder = { 0: 1, 2: 2, 4: 3, 5: 4 };
            const aReportStatus = reportOrder[a.report_status] || 5;
            const bReportStatus = reportOrder[b.report_status] || 5;

            if (aReportStatus !== bReportStatus) {
              return aReportStatus - bReportStatus;
            }

            const aBackupStatus = a.backup_status === 1 ? 2 : 1;
            const bBackupStatus = b.backup_status === 1 ? 2 : 1;

            if (aBackupStatus !== bBackupStatus) {
              return aBackupStatus - bBackupStatus;
            }
          });

        this.setState({
          patients: sortedData,
        });

        const data = {
          columns: [
            {
              label: "SL NO",
              field: "slno",
              sort: "asc",
              width: 5,
            },
            {
              label: "PATIENT ID",
              field: "patientId",
              sort: "asc",
              width: 70,
            },
            {
              label: "ADDED DATE",
              field: "added_date",
              sort: "asc",
              width: 70,
            },
            {
              label: "NAME",
              field: "name",
              sort: "asc",
              width: 130,
            },
            {
              label: "Action",
              field: "action",
              sort: "disabled",
              width: 160,
            },
          ],
          rows: [],
        };

        var onClick = this.selectItem.bind(this);
        var getInfo = this.getInfo.bind(this);

        var preventDefault = this.preventDefault.bind(this);
        var createdData = "";
        const options = [
          "RPeaks",
          "Classic",
          "Classical",
          "Classic Negative",
          "AI",
          "AIcodes",
        ];
        const defaultOption = options[0];
        sortedData.map(function (patient, i) {
          // console.log(patient);
          var url = " ";
          if (patient.LastDatasetId != undefined) {
            if (
              patient.backup_status == 0 ||
              patient.backup_status == undefined
            ) {
              url =
                "/verifier-unanalysed/" +
                patient._id +
                "/" +
                patient.LastDatasetId;
            } else {
              url = " ";
            }
          }

          var anl_btn_txt = "teststart";
          var anl_btn_class = "btn-danger";
          var gen_btn_txt = "Not Generated";
          var gen_btn_class = "btn-danger";
          var report_link = "#";
          var report_link_target = "";
          var report_status = patient.report_status;
          window.backup_status = patient.backup_status;
          if (patient.report_status == 1) {
            anl_btn_txt = "Analyzing...";
            anl_btn_class = "btn-success";
          }
          if (patient.report_status >= 2) {
            if (
              patient.backup_status == 0 ||
              patient.backup_status == undefined
            ) {
              url =
                "/verifier-chart/" + patient._id + "/" + patient.LastDatasetId;
            } else {
              url = " ";
            }
            anl_btn_txt = "test";
            anl_btn_class = "btn-success";
          }
          if (patient.report_status >= 4) {
            gen_btn_txt = "In Preparation";
            gen_btn_class = "btn-yellow";
          }
          if (patient.report_status >= 5) {
            gen_btn_txt = "View Report";
            gen_btn_class = "btn-success";
            report_link_target = "_blank";
          }

          if (
            patient.backup_status == 0 ||
            patient.backup_status == undefined
          ) {
            anl_btn_txt = "TEST3";
          } else if (patient.backup_status == 1) {
            anl_btn_txt = "Retrieve";
          } else if (patient.backup_status == 2) {
            anl_btn_txt = "Retrieving";
          }
          createdData = patient.created_at.split("T");
          data.rows.push({
            slno: i + 1,
            patientId: patient.device_id,
            added_date: createdData[0],

            confirmation: patient.Confirmation,
            name: capitalizeFirstLetter(patient.name),
            action: (
              <React.Fragment>
                {/* Flex row of compact dark-theme buttons — replaces the old
                    float-based light Bootstrap buttons. */}
                <div
                  style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}
                >
                  {this.state.verifiertype === "8" && (
                    <button
                      type="button"
                      id={patient._id}
                      onClick={getInfo}
                      data-toggle="modal"
                      data-target="#editInfoModal"
                      style={{ padding: "4px 12px", fontSize: "12px", fontWeight: 600, background: "#3a2e0e", border: "1px solid #f39c12", borderRadius: 6, color: "#f39c12", cursor: "pointer", whiteSpace: "nowrap" }}
                    >
                      ✏️ Edit
                    </button>
                  )}

                  <button
                    type="button"
                    id={patient._id}
                    onClick={onClick}
                    data-toggle="modal"
                    data-target="#myModalDHome"
                    style={{ padding: "4px 12px", fontSize: "12px", fontWeight: 600, background: "#0f4a52", border: "1px solid #2eaabb", borderRadius: 6, color: "#7fd8e5", cursor: "pointer", whiteSpace: "nowrap" }}
                  >
                    ⚙ Setting
                  </button>

                  {patient.QC === false && (
                    <button
                      type="button"
                      id={patient._id}
                      onClick={getInfo}
                      data-toggle="modal"
                      data-target="#commentinfomodal"
                      style={{ padding: "4px 12px", fontSize: "12px", fontWeight: 700, background: "#2a1a3a", border: "1px solid #b07fe5", borderRadius: 6, color: "#c9a6f0", cursor: "pointer", whiteSpace: "nowrap" }}
                    >
                      QC
                    </button>
                  )}
                  <button
                    type="button"
                    id={patient._id}
                    onClick={(e) => {
                      window.open(`${apiUrl3}?userid=${patient._id}`, "_blank");
                    }}
                    style={{ padding: "4px 12px", fontSize: "12px", fontWeight: 600, background: "#0e3a2e", border: "1px solid #2ecd99", borderRadius: 6, color: "#2ecd99", cursor: "pointer", whiteSpace: "nowrap" }}
                  >
                    📄 View Report
                  </button>
                </div>
              </React.Fragment>
            ),
          });
        }, this);
        this.setState({ data: data });
        this.setState({ columns: data.columns });
        this.setState({ rows: data.rows });
        this.setState({ patientsLoaded: true, patientsLoadError: false });
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        this.setState({ patientsLoaded: true, patientsLoadError: true });
      });

    $(document).ready(function () {
      $("#mbdTable").on("click", "tr td:nth-child(2)", function () {
        var url = $(this).parent().find(".patientLink").val();
        if (url != " ") {
          window.location.href = url;
        }
      });
      $("#mbdTable").on("click", "tr td:nth-child(3)", function () {
        var url = $(this).parent().find(".patientLink").val();
        if (url != " ") {
          window.location.href = url;
        }
      });
      $("#mbdTable").on("click", "tr td:nth-child(4)", function () {
        var url = $(this).parent().find(".patientLink").val();
        if (url != " ") {
          window.location.href = url;
        }
      });
    });
  };
  handleVerifierChange = (selectedOptions) => {
    this.setState({
      selectedVerifiers: selectedOptions || [], // Update selected verifiers or set empty array if none
    });
    // console.log('selected options',selectedOptions)
    // console.log('selected verifier state',this.state.selectedVerifiers,this.state.selectedVerifierIds)
  };

  submitComment = async (e) => {
    const userid = e.currentTarget.id;
    const verifiername = localStorage.getItem("verifiername");
    const buttonName = e.target.innerText.trim(); // Get the button name (Accepted or Rejected)
    const comments = `${this.state.comments} -BY ${verifiername}`;

    console.log("Button Clicked:", buttonName); // Console the button name

    try {
      const response = await axios.post(
        `${apiUrl}api/patients/addComment/${userid}`,
        { comments }
      );

      this.setState({ comments: "" });
      if (buttonName == "Accepted") {
        await axios.put(`${apiUrl}api/patients/updateqc/${userid}/1`);
      } else if (buttonName == "Rejected") {
        await axios.put(`${apiUrl}api/patients/updateqc/${userid}/0`);
      }
      $(".closePopup").click();
      this.fetchData();
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  sentMailReport = async (e) => {
    const mailid = this.state.customermailid;
    const userid = this.state.mailuserid;

    if (!userid || !mailid) {
      toast.error("Enter Email ID to proceed");
      return;
    }

    var apiUrl = `${apiUrl}api/users/sendmailReport_new_new_Read`;

    var requestBody = {
      userid: userid,
      mailid: mailid,
      mailsubject:
        this.state.mailsubject ||
        `${this.state.patientName}: Biocalculus: ${this.state.device_id}`,
    };

    await axios.post(`${apiUrl}api/users/updateMailId`, {
      mailid: this.state.customermailid,
      mac_id: this.state.device_mac,
      phone: this.state.whatsappNumber,
      device_id: this.state.device_id,
    });

    fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send email.");
          return data;
        })
      )
      .then((data) => {
        toast.success("Mail sent successfully!");
        $(".closePopup").click();
        this.setState({ customermailid: "", whatsappNumber: "", mailid: "" });
      })
      .catch((error) => {
        toast.error(error.message || "An error occurred while sending mail.");
      });
  };

  sentWhatsappReport = async (e) => {
    const number = this.state.whatsappNumber;
    const userid = this.state.mailuserid;
    const arrythymia = this.state.arrythymia || "NA";

    if (!arrythymia || !number) {
      toast.error("Enter WhatsApp number to proceed");
      return;
    }

    var apiUrl = `${apiUrl}api/common/whatsapp`;

    var requestBody = {
      user_id: userid,
      arrythymia: arrythymia,
      number: number,
    };

    fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send WhatsApp message.");
          return data;
        })
      )
      .then((data) => {
        toast.success("WhatsApp message sent successfully!");
        this.setState({
          customermailid: "",
          whatsappNumber: "",
          mailid: "",
          arrythymia: "",
        });
      })
      .catch((error) => {
        toast.error(
          error.message || "An error occurred while sending WhatsApp message."
        );
      });
  };
  sentMailReportPatient = async (e) => {
    const mailid = this.state.patientmailid;
    const userid = this.state.mailuserid;

    if (!userid || !mailid) {
      toast.error("Enter Email ID to proceed");
      return;
    }

    var apiUrl = `${apiUrl}api/users/sendmailReport_new_new_Read`;

    var requestBody = {
      userid: userid,
      mailid: mailid,
      mailsubject:
        this.state.patientmailsubject ||
        `${this.state.patientName}: Biocalculus: ${this.state.device_id}`,
    };

    fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send email.");
          return data;
        })
      )
      .then((data) => {
        toast.success("Mail sent successfully!");
        $(".closePopup").click();
      })
      .catch((error) => {
        toast.error(error.message || "An error occurred while sending mail.");
      });
  };

  sentWhatsappReportPatient = async (e) => {
    const number = this.state.patientwhatsappNumber;
    const userid = this.state.mailuserid;
    const arrythymia = this.state.arrythymia || "NA";

    if (!arrythymia || !number) {
      toast.error("Enter WhatsApp number to proceed");
      return;
    }

    var apiUrl = `${apiUrl}api/common/whatsapp`;

    var requestBody = {
      user_id: userid,
      arrythymia: arrythymia,
      number: number,
    };

    fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send WhatsApp message.");
          return data;
        })
      )
      .then((data) => {
        toast.success("WhatsApp message sent successfully!");
      })
      .catch((error) => {
        toast.error(
          error.message || "An error occurred while sending WhatsApp message."
        );
      });
  };

  handleModalComplete(id) {
    // console.log("id:", id);
    this.state.userid = id;
    this.setState({ isModalCompleteOpen: true });
  }
  onSubmit = (e) => {
    e.preventDefault();

    const settings = {
      userid: this.state.userid,
      nor_minhr: this.state.nor_minhr,
      nor_maxhr: this.state.nor_maxhr,
      qtcformula: this.state.qtcformula,
      qtcvalue_min: this.state.qtcvalue_min,
      qtcvaluemax: this.state.qtcvaluemax,
      qrswidth_min: this.state.qrswidth_min,
      qrswidth_max: this.state.qrswidth_max,
      qrsamp_min: this.state.qrsamp_min,
      qrsamp_max: this.state.qrsamp_max,
      stelevation: this.state.stelevation,
      pwidth_min: this.state.pwidth_min,
      pwidth_max: this.state.pwidth_max,
      pamp_min: this.state.pamp_min,
      pamp_max: this.state.pamp_max,
      stdepression: this.state.stdepression,
      twidth_min: this.state.twidth_min,
      twidth_max: this.state.twidth_max,
      tamp_min: this.state.tamp_min,
      tamp_max: this.state.tamp_max,
      printerval_min: this.state.printerval_min,
      printerval_max: this.state.printerval_max,
      tachyhr_lower: this.state.tachyhr_lower,
      tachyhr_upper: this.state.tachyhr_upper,
      bradyhr_lower: this.state.bradyhr_lower,
      bradyhr_upper: this.state.bradyhr_upper,
      pauselength: this.state.pauselength,
      graph_gen: this.state.graph_gen,
    };

    // console.log(settings);
    axios
      .post(apiUrl + "api/patients/updateSettings", settings)
      .then((res) => {
        $("#closePopup").click();
        // console.log("onclick");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onSubmitInfo = (e) => {
    e.preventDefault();

    //   this.state.selectedVerifiers.forEach(verifier => {
    //     console.log("Verifier ID:", verifier.value);
    // });

    const info = {
      name: this.state.patient_name,
      patientid: this.state.userid,
      userid: this.state.userid,
      dob: this.state.dob,
      weight: this.state.weight,
      height: this.state.height,
      hospital: this.state.hospital,
      phone: this.state.phone,
      email: this.state.email_id,
      doctorid: this.state.selectedDoctor.value,
      ipop: this.state.ipop,
      fileType: this.state.filetype || "easy",
      verifierid: this.state.selectedVerifiers.map(
        (verifier) => verifier.value
      ),
      priority: this.state.priority,

      reportstatus: this.state.reportstatus,
      // smoking: this.state.smoking,
      // diabetes: this.state.diabetes,
      af: this.state.af,
      // hyper_tension: this.state.hyper_tension,
      // hyper_lipidemia: this.state.hyper_lipidemia,
      hyper_lipidemia: this.state.pacemaker,
      indication: this.state.indication,
      cardiac_surgery: this.state.cardiac_surgery,
      thyroid: this.state.thyroid_function,
      exp_device_use_days: this.state.duration,
      issueReported: this.state.issueReport,
      supportLevel: this.state.supportLevel,
      supportPerson: this.state.supportPerson,
      supportcomment: this.state.supportedMatter,
      prioritizeData: this.state.prioritizeData, // <-- Add this line
      clinicalCondition: this.state.clinicalCondition, // <-- Add this line
    };
    // console.log("info:", this.state.clinicalCondition);

    const deviceinfoupdate = {
      mac_id: this.state.macid,
      priority: this.state.priority,
    };

    axios
      .post(apiUrl + "api/patients/updateInfo_new_info_test", info)
      .then((res) => {
        // Handle the response of the first request
        // console.log("Patient info updated:", res.data);
        if (this.state.macid != null) {
          // If macid is either undefined or null
          return axios.put(
            `${apiUrl}api/patients/updateDevicePriority`,
            deviceinfoupdate
          );
        }
      })

      .then((res) => {
        // Handle the response of the second request
        // console.log("Device priority updated:", res.data);
        $(".closePopup").click();
        this.fetchData(); // Fetch updated data
      })
      .catch((err) => {
        // Handle any errors from either request
        console.error("Error occurred:", err);
      });
  };
  onChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    // console.log("onChange");
    // console.log(e.target.name);
    // console.log(e.target.value);
    // console.log(e.target)
    // this.setState({reportstatus:e.target.value})
    // console.log(e.target.value)

    this.setState({ [e.target.name]: e.target.value });
  };
  onDurationChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ duration: e.target.value });
    // console.log(this.state.duration);
  };
  onPriorityChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];

    this.setState({ priority: e.target.value });
    // console.log(this.state.priority);
  };
  onReportStatuschange = (e) => {
    // console.log("report stats change",e.target.value)
    this.setState({ reportstatus: e.target.value });
  };

  preventDefault(e) {
    e.preventDefault();
  }

  getInfo(e) {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      loadingEditModal: true, // Set loading to true when starting
      supportPerson: "",
      supportLevel: "",
      supportedMatter: "",
    });
    this.setState({ isModalCompleteOpen: false });
    var userid = e.currentTarget.id;
    const dataid2 = e.target.getAttribute("dataid2");
    const dataid3 = e.target.getAttribute("dataid3");
    this.setState({ userid: userid });
    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];
        if (
          data.gender === "MALE" ||
          data.gender === "male" ||
          data.gender === "Male" ||
          data.gender === "M" ||
          data.gender === "m"
        ) {
          this.setState({ gender: "M" });
        }

        if (
          data.gender === "FEMALE" ||
          data.gender === "female" ||
          data.gender === "Female" ||
          data.gender === "F" ||
          data.gender === "f"
        ) {
          this.setState({ gender: "F" });
        }
        if (data.gender === "Select Gender") {
          this.setState({ gender: "M" });
        }

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        data.customer_details.forEach((customer) => {
          if (customer.customer_details) {
            // console.log('Nested Customer Details:', customer);
            this.setState({ customer_details: customer.customer_details });
          }
        });
        // console.log(this.state.patients);
        console.log("additional data!!!!!!!!!!!!!!!", data);
        // Update state with patient info
        this.setState({
          af: data.af ? "yes" : "no",
          duration: data.exp_device_use_days,
          cardiac_surgery: data.cardiac_surgery ? "yes" : "no",
          thyroid_function: data.thyroid,
          diabetes: data.diabetes,
          indication: data.indication,
          height: data.height,
          weight: data.weight,
          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          macid: dataid2,
          priority: dataid3,
          dob: data.dob,
          duration: data.exp_device_use_days,
          filetype: data.fileType,
          pacemaker: data.hyper_lipidemia,
          issueReport: data.issueReported,
          Confirmation: data.Confirmation,
          supportedMatter: data.supportcomment,
          supportPerson: data.supportPerson,
          supportLevel: data.supportLevel,
          prioritizeData: data.priorityStatus || "No",
          clinicalCondition: data.clinicalCondition || "", // <-- Add this line
        });
        // console.log("clinical condition:", data.clinicalCondition);
        // Handle DOB formatting
        let formattedDob = data.dob;
        if (formattedDob) {
          // Convert ISO string or YYYY-MM-DD to MM/DD/YYYY for display
          const dateObj = new Date(formattedDob);
          if (!isNaN(dateObj.getTime())) {
            const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
            const dd = String(dateObj.getDate()).padStart(2, "0");
            const yyyy = dateObj.getFullYear();
            formattedDob = `${mm}/${dd}/${yyyy}`;
          }
        }
        this.setState({ dob: formattedDob });
        // console.log("Formatted DOB:", this.state.dob);

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients, // Assuming patients is an array of user IDs
        }));

        const filteredVerifiers = formattedVerifiers.filter((verifier) =>
          verifier.patients.includes(userid)
        );

        // console.log('Filtered verifiers with matching user:', this.state.priority);

        this.setState({ selectedVerifiers: filteredVerifiers });

        this.setState({ verifiers: formattedVerifiers });
        // console.log('formatted verifiers:',verifiers)
        // Third API call for patient search (ipop)
        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            // this.setState({ priority: patient.priority });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // console.log("ipop", this.state.patients);

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues; // Assuming `ecgValues` is an array
        const totalLength = ecgValues.length;
        let verifyCount = 0; // Initialize verify count

        ecgValues.forEach((value, index) => {
          if (value.verifyStatus === 1) {
            // console.log(`Link for ECG value at index ${index}:`, value.link); // Assuming there's a 'link' property
            verifyCount++; // Increment the verify count
          }
        });

        // console.log('Total verified ECG values:', verifyCount);
        // console.log('Total count:', totalLength);

        if (totalLength > 0) {
          // console.log('ECG data is available.');

          // Calculate and log the percentage of verified ECG values
          const percentageVerified = (verifyCount / totalLength) * 100;
          // console.log('Percentage of verified ECG values:', percentageVerified.toFixed(2) + '%');
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
          // console.log('verified percentage:',this.state.percentageVerified)
        } else {
          // console.log('No ECG data found.');
        }
        this.setState({ loadingEditModal: false }); // Data loaded, hide spinner
        axios.get(`${apiUrl}api/common/getSupportPerson`).then((res) => {
          if (res.data && Array.isArray(res.data)) {
            this.setState({ supportPersons: res.data });
            // console.log("support persons:!!!!!!!!!!!!!!!!!!!!!!", this.state.supportPersons);
          }
        });
      })

      .catch((error) => {
        console.error("Error fetching ECG data:", error);
        this.setState({ loadingEditModal: false }); // Hide spinner on error
      });
  }

  selectItem(e) {
    var userid = e.currentTarget.id;
    this.setState({ userid: userid });
    this.setState({
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
    });
    axios
      .get(apiUrl + "api/patients/settings?userid=" + userid)
      .then((res) => {
        var data = res.data;
        this.setState(data);
      })
      .catch((err) => {
        // console.log(err);
      });
  }
  resetInfoModal() {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      customer_details: "", // Reset customer details too
      reportstatus: "",
      dob: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      doctor_name: "",
      doctor_id: "",
      duration: "",
      selectedVerifiers: [],
      verifiers: [],
      comments: "",
      priority: "",
      ipop: "",
      percentageVerified: "",
      loadingEditModal: false, // Reset loading state
    });
    // console.log(this.state.verifiers);
  }
  filterRows = () => {
    const { rows, searchQuery } = this.state;

    if (!searchQuery) {
      return rows; // If no search query, return all rows
    }

    return rows.filter((row) => {
      // You can modify this to check specific fields for a match
      return Object.values(row).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      );
    });
  };
  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleNextPage = () => {
    const totalPages = Math.ceil(
      this.filterRows().length / this.state.rowsPerPage
    );
    this.setState((prevState) => ({
      currentPage: Math.min(prevState.currentPage + 1, totalPages),
    }));
  };
  handlePrevPage = () => {
    this.setState((prevState) => ({
      currentPage: Math.max(prevState.currentPage - 1, 1),
    }));
  };
  handleRowClick(event) {
    const target = event.target;
    // console.log("clicked!!!!!!!!!!!");
    // Check if the click happened on the specific columns (2, 3, or 4)
    if (target.closest("td:nth-child(2), td:nth-child(3), td:nth-child(4)")) {
      const row = target.closest("tr");
      const button = row.querySelector("button");
      const userid = button ? button.id : null;
      const urlElement = row.querySelector(".patientLink");
      const databaseid = urlElement ? urlElement.value : ""; // Avoid optional chaining

      // Check if a URL exists and navigate to it

      const url = `verifier-chart/${userid}/${databaseid}`;
      window.location.href = url;
    }
  }
  handleToggle = (type) => {
    this.setState({ selectedType: type });
  };
  clearShareReportState = () => {
    this.setState({
      customermailid: "",
      whatsappNumber: "",
      mailid: "",
      arrythymia: "",
      patientmailid: "",
      patientwhatsappNumber: "",
      patientmailsubject: "",
      patientwhatsappMessage: "",
    });
  };

  // Add or update this method to handle date change from Datetime picker
  handleDateChange = (inputDate) => {
    let formattedDate = inputDate;
    if (
      inputDate &&
      typeof inputDate === "object" &&
      inputDate._isAMomentObject
    ) {
      // If using moment.js object from Datetime
      formattedDate = inputDate.format("MM/DD/YYYY");
    } else if (inputDate instanceof Date && !isNaN(inputDate.getTime())) {
      // If using native Date object
      const mm = String(inputDate.getMonth() + 1).padStart(2, "0");
      const dd = String(inputDate.getDate()).padStart(2, "0");
      const yyyy = inputDate.getFullYear();
      formattedDate = `${mm}/${dd}/${yyyy}`;
    } else if (typeof inputDate === "string") {
      // If string, try to parse as date
      const dateObj = new Date(inputDate);
      if (!isNaN(dateObj.getTime())) {
        const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
        const dd = String(dateObj.getDate()).padStart(2, "0");
        const yyyy = dateObj.getFullYear();
        formattedDate = `${mm}/${dd}/${yyyy}`;
      } else {
        formattedDate = inputDate;
      }
    }
    this.setState({ dob: formattedDate });
  };

  render() {
    const { currentPage, rowsPerPage } = this.state;
    const { columns, rows, dob } = this.state;

    const totalPages = Math.ceil(this.filterRows().length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const displayedRows = this.filterRows().slice(
      startIndex,
      startIndex + rowsPerPage
    );

    // Pagination range logic (show up to 8 page numbers)
    const paginationNumbers = [];
    const startPage = Math.max(1, currentPage - 4);
    const endPage = Math.min(totalPages, startPage + 7);

    for (let i = startPage; i <= endPage; i++) {
      paginationNumbers.push(i);
    }
    const filteredRows = this.filterRows();
    if (localStorage.jwtToken == undefined) {
      window.location.href = "/";
    }
    const { errors, doctors, selectedDoctor } = this.state;
    const options = doctors.map((doctor) => ({
      value: doctor._id,
      label: doctor.name,
    }));

    let doctorsList =
      this.state.doctors.length > 0 &&
      this.state.doctors.map((item, i) => {
        return (
          <option
            key={i}
            value={item._id}
            selected={this.state.doctor_name == item.name}
          >
            {item.name}
          </option>
        );
      }, this);

    return (
      <div className="wrapper theme-6-active box-layout pimary-color-green">
        <Toaster position="top-right" reverseOrder={false} />
        <TopNav profileLink={this.state.profileLink} />
        <AddModalComplete
          userid={this.state.userid}
          isOpen={this.state.isModalCompleteOpen}
        />
        <SideBar menus={this.state.menus} />
        <div className="right-sidebar-backdrop"></div>
        <div className="page-wrapper" style={{ marginTop: "6px", background: "#041415", minHeight: "100vh" }}>
          <div className="container-fluid" style={{ padding: "8px 4px" }}>
            <div id="myModalDHome" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      General Settings
                    </h4>
                  </div>
                  <form method="post" onSubmit={this.onSubmit}>
                    <div className="modal-body">
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_minhr,
                              })}
                              name="nor_minhr"
                              required=""
                              id="nor_minhr"
                              onChange={this.onChange}
                              value={this.state.nor_minhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_maxhr,
                              })}
                              name="nor_maxhr"
                              required=""
                              id="nor_maxhr"
                              onChange={this.onChange}
                              value={this.state.nor_maxhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Formula
                            </label>
                            <select
                              name="qtcformula"
                              className={classnames("form-control", {
                                errors: errors.qtcformula,
                              })}
                              value={this.state.qtcformula}
                              onChange={this.onChange}
                            >
                              <option value="Bazett">Bazett </option>
                              <option value="Fridericia">Fridericia</option>
                              <option value="Framingham">Framingham</option>
                              <option value="Hodges">Hodges</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvalue_min,
                              })}
                              name="qtcvalue_min"
                              required=""
                              id="qtcvalue_min"
                              onChange={this.onChange}
                              value={this.state.qtcvalue_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvaluemax,
                              })}
                              name="qtcvaluemax"
                              required=""
                              id="qtcvaluemax"
                              onChange={this.onChange}
                              value={this.state.qtcvaluemax}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Min(ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_min,
                              })}
                              name="qrswidth_min"
                              required=""
                              id="qrswidth_min"
                              onChange={this.onChange}
                              value={this.state.qrswidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Max (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_max,
                              })}
                              name="qrswidth_max"
                              required=""
                              id="qrswidth_max"
                              onChange={this.onChange}
                              value={this.state.qrswidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_min,
                              })}
                              name="qrsamp_min"
                              required=""
                              id="qrsamp_min"
                              onChange={this.onChange}
                              value={this.state.qrsamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_max,
                              })}
                              name="qrsamp_max"
                              required=""
                              id="qrsamp_max"
                              onChange={this.onChange}
                              value={this.state.qrsamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Elevation (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stelevation,
                              })}
                              name="stelevation"
                              required=""
                              id="stelevation"
                              onChange={this.onChange}
                              value={this.state.stelevation}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Min (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_min,
                              })}
                              name="pwidth_min"
                              required=""
                              id="pwidth_min"
                              onChange={this.onChange}
                              value={this.state.pwidth_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_max,
                              })}
                              name="pwidth_max"
                              required=""
                              id="pwidth_max"
                              onChange={this.onChange}
                              value={this.state.pwidth_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_min,
                              })}
                              name="pamp_min"
                              required=""
                              id="pamp_min"
                              onChange={this.onChange}
                              value={this.state.pamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_max,
                              })}
                              name="pamp_max"
                              required=""
                              id="pamp_max"
                              onChange={this.onChange}
                              value={this.state.pamp_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Min (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_min,
                              })}
                              name="twidth_min"
                              required=""
                              id="twidth_min"
                              onChange={this.onChange}
                              value={this.state.twidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_max,
                              })}
                              name="twidth_max"
                              required=""
                              id="twidth_max"
                              onChange={this.onChange}
                              value={this.state.twidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_min,
                              })}
                              name="tamp_min"
                              required=""
                              id="tamp_min"
                              onChange={this.onChange}
                              value={this.state.tamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_max,
                              })}
                              name="tamp_max"
                              required=""
                              id="tamp_max"
                              onChange={this.onChange}
                              value={this.state.tamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Min{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_min,
                              })}
                              name="printerval_min"
                              required=""
                              id="printerval_min"
                              onChange={this.onChange}
                              value={this.state.printerval_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Max{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_max,
                              })}
                              name="printerval_max"
                              required=""
                              id="printerval_max"
                              onChange={this.onChange}
                              value={this.state.printerval_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_lower,
                              })}
                              name="tachyhr_lower"
                              required=""
                              id="tachyhr_lower"
                              onChange={this.onChange}
                              value={this.state.tachyhr_lower}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_upper,
                              })}
                              name="tachyhr_upper"
                              required=""
                              id="tachyhr_upper"
                              onChange={this.onChange}
                              value={this.state.tachyhr_upper}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_lower,
                              })}
                              name="bradyhr_lower"
                              required=""
                              id="bradyhr_lower"
                              onChange={this.onChange}
                              value={this.state.bradyhr_lower}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_upper,
                              })}
                              name="bradyhr_upper"
                              required=""
                              id="bradyhr_upper"
                              onChange={this.onChange}
                              value={this.state.bradyhr_upper}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Depression (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stdepression,
                              })}
                              name="stdepression"
                              required=""
                              id="stdepression"
                              onChange={this.onChange}
                              value={this.state.stdepression}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Pause Length (s){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pauselength,
                              })}
                              name="pauselength"
                              required=""
                              id="pauselength"
                              onChange={this.onChange}
                              value={this.state.pauselength}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Graphs To Be Generated(no:){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.graph_gen,
                              })}
                              name="graph_gen"
                              required=""
                              id="graph_gen"
                              onChange={this.onChange}
                              value={this.state.graph_gen}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="submit"
                        className="btn btn-success"
                        style={{ color: "Black" }}
                      >
                        Submit
                      </button>
                      {
                        <button
                          id="closePopup"
                          type="button"
                          className="btn btn-default closePopup"
                          data-dismiss="modal"
                          style={{ color: "Black" }}
                        >
                          Close
                        </button>
                      }
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              id="commentinfomodal"
              className="modal fade"
              role="dialog"
              aria-labelledby="commentModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4
                      className="modal-title text-center"
                      id="commentModalLabel"
                    >
                      Add comments
                    </h4>
                  </div>

                  <div className="modal-body">
                    <textarea
                      value={this.state.comments || ""} // Default to empty string if comments is undefined
                      style={{ width: "100%", height: "100px", color: "black" }}
                      placeholder="Enter your comments here"
                      onChange={(e) =>
                        this.setState({ comments: e.target.value })
                      } // Update comments directly in state
                    />
                  </div>
                  <div className="modal-footer">
                    <div className="row row-sm-offset">
                      <div className="col-md-6 multi-horizontal">
                        <button
                          type="button"
                          id={this.state.userid}
                          className="btn btn-danger"
                          data-dismiss="modal"
                          style={{ color: "Black" }}
                          onClick={this.submitComment}
                        >
                          Rejected
                        </button>
                      </div>
                      <div className="col-md-6 multi-horizontal text-left">
                        <button
                          id={this.state.userid}
                          type="submit"
                          className="btn btn-success"
                          style={{ color: "Black" }}
                          onClick={this.submitComment}
                        >
                          Accepted
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="mailinfomodal"
              className="modal fade"
              role="dialog"
              aria-labelledby="mailinfomodal"
              aria-hidden="true"
              onClick={this.clearShareReportState}
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.clearShareReportState}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title text-center">Share Report</h4>
                  </div>

                  <div className="modal-body">
                    {/* Switch Selector for Customer/Patient */}
                    <div className="switch-container">
                      <div
                        className={`switch-option ${
                          this.state.selectedType === "customer" ? "active" : ""
                        }`}
                        onClick={() =>
                          this.setState({ selectedType: "customer" })
                        }
                      >
                        Customer
                      </div>
                      <div
                        className={`switch-option ${
                          this.state.selectedType === "patient" ? "active" : ""
                        }`}
                        onClick={() =>
                          this.setState({ selectedType: "patient" })
                        }
                      >
                        Patient
                      </div>
                    </div>

                    {/* Dynamic Form Section */}
                    {this.state.selectedType === "customer" ? (
                      <>
                        {/* Mail Report Section */}
                        <div className="mail-section">
                          <h5>Mail Report (Customer):</h5>
                          <input
                            value={this.state.customermailid}
                            style={{ width: "100%", marginBottom: "10px" }}
                            placeholder="Enter customer email..."
                            onChange={(e) =>
                              this.setState({ customermailid: e.target.value })
                            }
                          />
                          <textarea
                            onChange={(e) =>
                              this.setState({ mailsubject: e.target.value })
                            }
                            value={this.state.mailsubject}
                            placeholder="Enter email subject..."
                            style={{ width: "100%", height: "80px" }}
                          />
                        </div>

                        <hr />

                        {/* WhatsApp Report Section */}
                        <div className="whatsapp-section">
                          <h5>WhatsApp Report (Customer):</h5>
                          <input
                            value={this.state.whatsappNumber}
                            style={{ width: "100%", marginBottom: "10px" }}
                            placeholder="Enter customer WhatsApp number..."
                            onChange={(e) =>
                              this.setState({ whatsappNumber: e.target.value })
                            }
                          />
                          <textarea
                            onChange={(e) =>
                              this.setState({ arrythymia: e.target.value })
                            }
                            value={this.state.whatsappMessage}
                            placeholder="Enter WhatsApp message..."
                            style={{ width: "100%", height: "80px" }}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {/* Mail Report Section for Patient */}
                        <div className="mail-section">
                          <h5>Mail Report (Patient):</h5>
                          <input
                            value={this.state.patientmailid}
                            style={{ width: "100%", marginBottom: "10px" }}
                            placeholder="Enter patient email..."
                            onChange={(e) =>
                              this.setState({ patientmailid: e.target.value })
                            }
                          />
                          <textarea
                            onChange={(e) =>
                              this.setState({
                                patientmailsubject: e.target.value,
                              })
                            }
                            value={this.state.patientmailsubject}
                            placeholder="Enter email subject..."
                            style={{ width: "100%", height: "80px" }}
                          />
                        </div>

                        <hr />

                        {/* WhatsApp Report Section for Patient */}
                        <div className="whatsapp-section">
                          <h5>WhatsApp Report (Patient):</h5>
                          <input
                            value={this.state.patientwhatsappNumber}
                            style={{ width: "100%", marginBottom: "10px" }}
                            placeholder="Enter patient WhatsApp number..."
                            onChange={(e) =>
                              this.setState({
                                patientwhatsappNumber: e.target.value,
                              })
                            }
                          />
                          <textarea
                            onChange={(e) =>
                              this.setState({
                                arrythymia: e.target.value,
                              })
                            }
                            value={this.state.arrythymia}
                            placeholder="Enter WhatsApp message..."
                            style={{ width: "100%", height: "80px" }}
                          />
                        </div>
                      </>
                    )}
                  </div>

                  <div className="modal-footer">
                    <button
                      type="submit"
                      className="btn btn-success"
                      onClick={() => {
                        if (this.state.selectedType === "customer") {
                          this.sentMailReport();
                          this.sentWhatsappReport();
                        } else {
                          this.sentMailReportPatient();
                          this.sentWhatsappReportPatient();
                        }
                        this.clearShareReportState();
                      }}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-default"
                      data-dismiss="modal"
                      onClick={this.clearShareReportState}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="whatsappinfomodal"
              className="modal fade"
              role="dialog"
              aria-labelledby="whatsappinfomodal"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4
                      className="modal-title text-center"
                      id="whatsappinfomodal"
                      value={this.state.whatsappNumber || ""} // Default to empty string if comments is undefined
                      style={{ width: "100%", color: "black" }}
                      placeholder="Enter whatsapp to share report....."
                      onChange={(e) =>
                        this.setState({ whatsappNumber: e.target.value })
                      } // Update comments directly in state
                    />
                    <textarea
                      onChange={(e) => {
                        const value = e.target.value; // Get the current value
                        // console.log("Typing value:", value); // Log the value to the console
                        this.setState({ arrythymia: value }); // Update state
                      }}
                      // value={this.state.mailsubject} // Bind to the dynamic state
                      placeholder="Enter Report Subject Here..."
                      className="subject-textarea"
                    />
                  </div>
                  <div className="modal-footer">
                    <div className="row row-sm-offset">
                      <div className="col-md-6 multi-horizontal">
                        <button
                          id={this.state.userid}
                          type="submit"
                          className="btn btn-success"
                          style={{ color: "Black" }}
                          onClick={this.sentWhatsappReport}
                        >
                          Submit
                        </button>
                      </div>
                      <div className="col-md-6 multi-horizontal text-left">
                        <button
                          type="button"
                          className="btn btn-default closePopup"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="editInfoModal"
              className="modal fade"
              role="dialog"
              data-backdrop="static"
              data-keyboard="false"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      onClick={this.resetInfoModal.bind(this)}
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      Edit Patient Information
                    </h4>
                  </div>

                  <form method="post" onSubmit={this.onSubmitInfo}>
                    <div
                      className="modal-body"
                      style={{ position: "relative" }}
                    >
                      {/* Full-modal loading overlay */}
                      {this.state.loadingEditModal && (
                        <div
                          className="modal-loading-overlay"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(255,255,255,0.7)",
                            zIndex: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            className="spinner-edit-modal"
                            style={{
                              width: 48,
                              height: 48,
                              border: "6px solid #f3f3f3",
                              borderTop: "6px solid #3498db",
                              borderRadius: "50%",
                              animation: "spin 1s linear infinite",
                            }}
                          ></div>
                          <style>{`@keyframes spin { 
                0% { transform: rotate(0deg); } 
                100% { transform: rotate(360deg); } 
              }`}</style>
                        </div>
                      )}

                      {/* Row 1: Name, Email, Phone */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="patient_name"
                              onChange={this.onChange}
                              value={this.state.patient_name}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Email</label>
                            <input
                              type="text"
                              className="form-control"
                              name="email_id"
                              onChange={this.onChange}
                              value={this.state.email_id}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Phone</label>
                            <input
                              type="text"
                              className="form-control"
                              name="phone"
                              onChange={this.onChange}
                              value={this.state.phone}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 2: Doctor Name, Hospital, IP/OP */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Hospital Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="hospital"
                              onChange={this.onChange}
                              value={this.state.hospital}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Doctor Name
                            </label>
                            <Select
                              options={options}
                              value={selectedDoctor}
                              onChange={this.handleDoctorChange}
                              placeholder="Search Doctor"
                              classNamePrefix="react-select"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  borderColor: errors.doctor_id
                                    ? "red"
                                    : base.borderColor,
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>IP/OP</label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.onIpOpChange}
                              value={this.state.ipop}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 3: DOB + File Type + Confirmation */}
                      <div className="row">
                        {/* DOB */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>DOB</label>
                            <div className="input-group">
                              <Datetime
                                value={dob}
                                onChange={this.handleDateChange}
                                inputProps={{
                                  className: `form-control ${
                                    errors.dob ? "is-invalid" : ""
                                  }`,
                                  placeholder: "Select Date",
                                }}
                                dateFormat="MM/DD/YYYY"
                                timeFormat={false}
                              />
                              <span className="input-group-addon">
                                <span className="fa fa-calendar"></span>
                              </span>
                            </div>
                            {errors.dob && (
                              <div className="invalid-feedback">
                                {errors.dob}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* File Type */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>File Type</label>
                            <select
                              className="form-control"
                              value={this.state.filetype}
                              onChange={this.handleTypeChange}
                            >
                              <option value="easy">Easy</option>
                              <option value="moderate">Moderate</option>
                              <option value="hard">Hard</option>
                            </select>
                          </div>
                        </div>

                        {/* Confirmation */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Confirmation
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "#fff",
                              }}
                              value={this.state.Confirmation}
                              readOnly
                              onClick={this.handleConfirmationClick}
                              placeholder="Select Confirmation"
                              data-toggle="modal"
                              data-target="#ConfirmInfoModal"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 4: Priority, Report Status, Atrial Fib */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Priority</label>
                            <select
                              className="form-control"
                              value={this.state.priority}
                              onChange={this.onPriorityChange}
                            >
                              <option value="4">NA</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Report Status
                            </label>
                            <select
                              className="form-control"
                              value={this.state.reportstatus}
                              onChange={this.onReportStatuschange}
                            >
                              <option value="0">Not Analayzed</option>
                              <option value="6">Analyze Completed</option>
                              <option value="3">Verification Completed</option>
                              <option value="4">In Preparation</option>
                              <option value="5">Report Completed</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Atrial Fibrillation
                            </label>
                            <select
                              className="form-control"
                              value={this.state.af}
                              onChange={this.onChange}
                            >
                              <option value="">Choose</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Row 5: Indication, Duration, Gender */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Indication</label>
                            <input
                              type="text"
                              className="form-control"
                              name="indication"
                              onChange={this.onChange}
                              value={this.state.indication}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Monitoring Duration
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.onDurationChange}
                              value={this.state.duration}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Gender</label>
                            <select
                              className="form-control"
                              onChange={this.onGenderChange}
                              value={this.state.gender}
                            >
                              <option value="M">M</option>
                              <option value="F">F</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Row 6: Issue Noticed, Cardiac Surgery, Pacemaker */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Issue Noticed
                            </label>
                            <select
                              className="form-control"
                              value={this.state.issueReport}
                              onChange={(e) =>
                                this.setState({ issueReport: e.target.value })
                              }
                            >
                              <option value="NA">Not Selected</option>
                              <option value="repeat">Repeat</option>
                              <option value="low_data">Low data</option>
                              <option value="customer_reject">
                                Customer Reject
                              </option>
                              <option value="battery_issue">
                                Battery Issue
                              </option>
                              <option value="device_issue">Device Issue</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Cardiac Surgery/Interventions
                            </label>
                            <select
                              className="form-control"
                              value={this.state.cardiac_surgery}
                              onChange={this.onChange}
                            >
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Pacemaker</label>
                            <select
                              className="form-control"
                              value={this.state.pacemaker}
                              onChange={(e) => {
                                this.setState({
                                  pacemaker: e.target.value === "true",
                                });
                              }}
                            >
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      {/* Row 7: Support Person + Support Level + Supported Matter */}
                      <div className="row">
                        {/* Support Person Dropdown */}
                        {/* Support Person Dropdown */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Support Person
                            </label>
                            <select
                              className="form-control"
                              value={this.state.supportPerson}
                              onChange={(e) =>
                                console.log(e.target.value) ||
                                this.setState({ supportPerson: e.target.value })
                              }
                            >
                              <option value="">Select Person</option>
                              {this.state.supportPersons &&
                              this.state.supportPersons.length > 0 ? (
                                this.state.supportPersons.map((person) => (
                                  <option key={person._id} value={person._id}>
                                    {person.name}
                                  </option>
                                ))
                              ) : (
                                <option disabled>Loading...</option>
                              )}
                            </select>
                          </div>
                        </div>

                        {/* Support Level Dropdown */}
                        <div className="col-md-2">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Support Level
                            </label>
                            <select
                              className="form-control"
                              value={this.state.supportLevel}
                              onChange={(e) =>
                                console.log(e.target.value) ||
                                this.setState({ supportLevel: e.target.value })
                              }
                            >
                              <option value="">Select Level</option>
                              <option value="L0">L0</option>
                              <option value="L1">L1</option>
                              <option value="L2">L2</option>
                              <option value="L3">L3</option>
                            </select>
                          </div>
                        </div>

                        {/* Supported Matter Textarea */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Supported Matter
                            </label>
                            <textarea
                              className="form-control"
                              rows="3"
                              value={this.state.supportedMatter}
                              onChange={(e) =>
                                // console.log(e.target.value) ||
                                this.setState({
                                  supportedMatter: e.target.value,
                                })
                              }
                              placeholder="Enter details..."
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Prioritize Data
                            </label>
                            <select
                              className="form-control"
                              value={this.state.prioritizeData}
                              onChange={(e) =>
                                this.setState({
                                  prioritizeData: e.target.value,
                                })
                              }
                            >
                              <option value="No">No</option>
                              <option value="Yes">Yes</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Assign Verifier
                            </label>
                            <Select
                              isMulti
                              options={this.state.verifiers}
                              value={this.state.selectedVerifiers}
                              onChange={this.handleVerifierChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              placeholder="Select verifiers..."
                              styles={{
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: state.isSelected
                                    ? "blue"
                                    : state.isFocused
                                    ? "#e5e5e5"
                                    : null,
                                  color: state.isSelected ? "white" : "black",
                                }),
                                multiValue: (provided) => ({
                                  ...provided,
                                  backgroundColor: "blue",
                                }),
                                multiValueLabel: (provided) => ({
                                  ...provided,
                                  color: "white",
                                }),
                              }}
                            />

                            {this.state.selectedVerifiers.length > 0 && (
                              <div style={{ marginTop: "10px" }}>
                                <strong>Selected Verifiers:</strong>{" "}
                                {this.state.selectedVerifiers
                                  .map((verifier) => verifier.label)
                                  .join(", ")}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Row 9: Clinical Condition */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Clinical Condition
                            </label>
                            <textarea
                              className="form-control"
                              rows="3"
                              value={this.state.clinicalCondition}
                              onChange={(e) =>
                                this.setState({
                                  clinicalCondition: e.target.value,
                                })
                              }
                              placeholder="Enter clinical condition..."
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Footer with separate divs for Submit and Close */}
                    <div className="modal-footer d-flex justify-content-center gap-3">
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={this.state.loadingEditModal}
                      >
                        Submit
                      </button>

                      <button
                        type="button"
                        className="btn btn-default closePopup"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="row" style={{ margin: 0 }}>
              <div className="col-sm-12" style={{ padding: "0 8px" }}>
                <div style={{ background: "#072224", borderRadius: "6px", overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.25)" }}>

                  {/* ── Compact toolbar: title + count + search ── */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", background: "#0c2e32", borderBottom: "2px solid #1e6b72", flexWrap: "wrap", gap: 8 }}>
                    <span style={{ color: "#ffffff", fontWeight: 700, fontSize: "14px", letterSpacing: "0.4px" }}>
                      🧪 QC — Patient List
                      {filteredRows.length > 0 && (
                        <span style={{ marginLeft: 8, fontSize: "11px", fontWeight: 600, color: "#ffffff", background: "#1a6a72", borderRadius: 10, padding: "2px 10px", border: "1px solid #2a9aaa" }}>
                          {filteredRows.length} shown
                        </span>
                      )}
                    </span>
                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                      <span style={{ position: "absolute", left: 9, color: "#2eaabb", fontSize: "14px", pointerEvents: "none" }}>🔍</span>
                      <input
                        type="text"
                        placeholder="Search patient…"
                        style={{ height: 34, paddingLeft: 30, paddingRight: 10, fontSize: "12px", borderRadius: 6, border: "2px solid #2eaabb", background: "#0f4a52", color: "#ffffff", outline: "none", width: 215, fontWeight: 500, boxShadow: "0 0 0 1px rgba(46,170,187,0.3)" }}
                        value={this.state.searchQuery}
                        onChange={this.handleSearchChange}
                      />
                    </div>
                  </div>

                  <div style={{ padding: 0 }}>
                    <table className="table table-striped" style={{ width: "100%", tableLayout: "fixed", marginBottom: 0 }}>
                      <colgroup>
                        <col style={{ width: "6%" }} />
                        <col style={{ width: "14%" }} />
                        <col style={{ width: "14%" }} />
                        <col style={{ width: "24%" }} />
                        <col style={{ width: "42%" }} />
                      </colgroup>
                      <thead>
                        <tr style={{ background: "#031213" }}>
                          {columns.map((col, index) => (
                            <th key={index} style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>
                              {col.label}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {displayedRows.map((row, rowIndex) => (
                          <tr
                            key={rowIndex}
                            style={{ backgroundColor: row.backgroundColor }}
                          >
                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>{startIndex + rowIndex + 1}</td>
                            <td
                              onClick={this.handleRowClick}
                              style={{ cursor: "pointer", verticalAlign: "middle", textAlign: "center", fontWeight: 700, fontSize: "13px" }}
                            >
                              {row.patientId}
                            </td>
                            <td
                              onClick={this.handleRowClick}
                              style={{ cursor: "pointer", verticalAlign: "middle", textAlign: "center" }}
                            >
                              {row.added_date}
                            </td>
                            <td
                              onClick={this.handleRowClick}
                              style={{ cursor: "pointer", verticalAlign: "middle" }}
                            >
                              {row.name}
                              {row.confirmation === "Live" && <LiveTag />}
                            </td>
                            <td style={{ verticalAlign: "middle" }}>{row.action}</td>
                          </tr>
                        ))}
                        {displayedRows.length === 0 && (
                          <tr>
                            <td colSpan={5} style={{ textAlign: "center", padding: "24px 0", color: "#89a8c0", fontSize: "13px" }}>
                              {!this.state.patientsLoaded
                                ? "Loading patients..."
                                : this.state.patientsLoadError
                                ? "Could not load patients. Please refresh the page."
                                : "No patients found."}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalPages > 1 && (
                      <div
                        className="pagination-container"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: 4,
                          padding: "10px 14px",
                          borderTop: "1px solid #0c2e30",
                        }}
                      >
                        <button
                          onClick={this.handlePrevPage}
                          disabled={currentPage === 1}
                          style={{
                            border: "1px solid #2eaabb",
                            padding: "5px 12px",
                            cursor: currentPage === 1 ? "not-allowed" : "pointer",
                            borderRadius: "6px",
                            background: "#0f4a52",
                            color: "#ffffff",
                            fontSize: "12px",
                            fontWeight: 600,
                            opacity: currentPage === 1 ? 0.4 : 1,
                          }}
                        >
                          ← Prev
                        </button>
                        {paginationNumbers.map((num) => (
                          <button
                            key={num}
                            onClick={() => this.handlePageChange(num)}
                            style={{
                              fontWeight: num === currentPage ? 700 : 500,
                              backgroundColor: num === currentPage ? "#2eaabb" : "#0f4a52",
                              color: "#ffffff",
                              border: "1px solid #2eaabb",
                              padding: "5px 12px",
                              cursor: "pointer",
                              borderRadius: "6px",
                              fontSize: "12px",
                            }}
                          >
                            {num}
                          </button>
                        ))}
                        <button
                          onClick={this.handleNextPage}
                          disabled={currentPage === totalPages}
                          style={{
                            border: "1px solid #2eaabb",
                            padding: "5px 12px",
                            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                            borderRadius: "6px",
                            background: "#0f4a52",
                            color: "#ffffff",
                            fontSize: "12px",
                            fontWeight: 600,
                            opacity: currentPage === totalPages ? 0.4 : 1,
                          }}
                        >
                          Next →
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default QC_Home;
